import { style } from 'typestyle'
export const ml4 = style({ marginLeft: '4px' })
